import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { ProcurementType } from './procurement-types/procurement-types.entity';
import { ProcurementTypesModule } from './procurement-types/procurement-types.module';
import { GrnReturnsModule } from './grn-returns/grn-returns.module';
import { PoCreationModule } from './po-creation/po-creation.module';
import { GrnModule } from './grn/grn.module';
import { PoItems } from './po-creation/po-creation-items.entity';
import { PoCreation } from './po-creation/po-creation.entity';
import { StoreConsumptionModule } from './store-consumption/store-consumption.module';
import { StoreConsumption } from './store-consumption/entity/store-consumption.entity';
import { StoreConsumptionItems } from './store-consumption/entity/store-consumption-items.entity';
import { Grn } from './grn/grn.entity';
import { GrnItems } from './grn/grn-items.entity';
import { StoreReturn } from './store-returns/store-return.entity';
import { StockModule } from './stock/stock.module';
import { Stock } from './stock/stock.entity';
import { LoggerModule, PinoLogger } from 'nestjs-pino';
import procurementConfigs from '../../config';
import { QueryLogger } from '../../../logger/query-logger';
import { GrnItemReturns } from './grn-returns/grn-item-return-entity';
import { appSettings } from '../../../config';
import { StoreReturnsModule } from './store-returns/store-returns.module';
import { AssetsPoModule } from './assets-po/assets-po.module';
import { AssetsPo } from './assets-po/assets-po-entity';
import { TransferMaterialModule } from './transfer-material/transfer-material.module';
import { TransferInfo } from './transfer-material/entities/transfer-material.entity';
import { TransferItems } from './transfer-material/entities/transfer-items.entity';
import { GrnReturns } from './grn-returns/grn-return-entity';
import { ProductConversion } from './stock/product-conversion-entity';
import { ReturnReq } from './store-consumption/dto/store-return-req';
import { CycleChecker } from './stock/cycle-checker.entity';
import { AssignedStockLog } from './stock/assigned-stock-log.entity';
import { PreapredStock } from './stock/prepared-stock.entity';
import { PlaceListItems } from './store-consumption/entity/place_list_items.entity';
import { AsnItems } from './asn/asn-items.entity';
import { Asn } from './asn/asn.entity';
import { AsnModule } from './asn/asn.module';
import { IndentForm } from './store-consumption/entity/packing-indent.entity';
import { EtdWise } from './store-consumption/entity/etd-wise-grid.entity';
import { PackingIndent } from './indent/packing-indent.entity';
import { PackingIndentModule } from './indent/indent.module';
import { IndentMaterialEntity } from './indent-form-for-material-preparation/indent-form-entity';
import { IndentItemEntity } from './indent-form-for-material-preparation/indent-item-entity';
import { IndentFormModule } from './indent-form-for-material-preparation/indent-form-module';
import { StockLog } from './stock/stock-log.entity';
import { LocationWiseTranfers } from './transfer-material/entities/location-wise-transfers.entity';
import { InvntoryLogs } from './stock/inventory-logs';
@Module({
  imports: [
    // LoggerModule.forRoot({ pinoHttp: { level: procurementConfigs.loggingMode } }),
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.procure_db,
      entities: [
        ProcurementType,
        PoCreation,
        PoItems,
        StoreConsumption,
        StoreConsumptionItems,
        Grn,
        GrnItems,
        StoreReturn,
        Stock,
        GrnReturns,
        GrnItemReturns,
        AssetsPo,
        TransferInfo,
        TransferItems,
        LocationWiseTranfers,
        ProductConversion,
        ReturnReq,
        CycleChecker,
        AssignedStockLog,
        PreapredStock,
        PlaceListItems,
        Asn,
        AsnItems,
        IndentForm,
        EtdWise,
        PackingIndent,
        IndentMaterialEntity,
        IndentItemEntity,
        StockLog,
        InvntoryLogs
      ],
      // synchronize: mastersConfigs.sync,
      synchronize: false,
      logging: true,
      // logger: new QueryLogger(new PinoLogger({ pinoHttp: { level: procurementConfigs.loggingMode } })),
    }),
    ProcurementTypesModule,
    GrnReturnsModule,
    PoCreationModule,
    GrnModule,
    StoreConsumptionModule,
    StockModule, StoreReturnsModule, AssetsPoModule, TransferMaterialModule,AsnModule,PackingIndentModule,IndentFormModule],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }
